export interface IVehiclePlateChars {
	chars: { code: string; name: string }[];
}

const model = {
	chars: ['response.getVehiclePlateCharCodesResponse.response', []],
};

export default model;
